/**
 * @file        src/pages/flight/CorporateSearchHistory.jsx
 * @description Corporate Flight → Search History. Same list as the B2C Flight
 *              Search History (SearchHistory.jsx), fixed to audience=b2b,
 *              instead of forking the page.
 * @author      Kinetika Labs
 * @created     2026-08-10
 * @changelog
 *   - 2026-09-22 Claude — Points its "View analytics" link at the CORPORATE
 *                          analytics screen. Passed as a prop rather than derived
 *                          from `audience`, so the boundary stays fixed by the
 *                          screen and not by a URL (CLAUDE.md §9d).
 *   - 2026-08-10 Claude — Initial (Corporate Flight menu parity with B2C).
 */
import SearchHistory from './SearchHistory';

export default function CorporateSearchHistory() {
  return (
    <SearchHistory
      title="Corporate Search History"
      subtitle="Corporate Flight · B2B customer searches"
      audience="b2b"
      analyticsTo="/flight/corporate-search-analytics"
    />
  );
}
